<script lang="ts">
	import { browser } from '$app/environment';
	import { afterNavigate } from '$app/navigation';
	import { page } from '$app/state';
	import { adminStore } from '$lib/stores/admin';
	import { businessStore } from '$lib/stores/business';
	import { chatEnabled, chatSupportHasMessageStore, chattingWithUser } from '$lib/stores/chat';
	import { hasConfigurationIssues } from '$lib/stores/settings';
	import { userStore } from '$lib/stores/user';
	import { onMount } from 'svelte';

	let loaded = $state(false);
	let mounted = $state(false);

	// Send the current urls in Crisp
	afterNavigate(({ to }) => {
		window.$crisp.push([
			'set',
			'session:event',
			[[['navigate_to_page', { url: to.url.pathname }, 'green']]]
		]);
	});

	function mountChat() {
		window.$crisp.push(['safe', true]);
		window.$crisp.push([
			'on',
			'message:received',
			() => {
				if (!$chatEnabled) {
					$chatSupportHasMessageStore = true;
				}
			}
		]);

		// Callback when chat is loaded
		window.$crisp.push([
			'on',
			'session:loaded',
			function () {
				loaded = true;
				if (window.$crisp.get('chat:unread:count') > 0) {
					$chatSupportHasMessageStore = true;
				}
			}
		]);

		// Keep chat open in the app if user opens it
		window.$crisp.push([
			'on',
			'chat:opened',
			function () {
				$chattingWithUser = true;
			}
		]);
		window.$crisp.push([
			'on',
			'chat:closed',
			function () {
				$chattingWithUser = false;
			}
		]);

		window.$crisp.push(['do', 'chat:hide']);
		window.$crisp.push(['do', 'chat:close']);
		mounted = true;
	}

	// Initialize Crisp
	onMount(() => {
		window.$crisp = [];
		window.CRISP_WEBSITE_ID = '4abff3b1-d336-4eaf-ab64-67c18ba5f2ab';
		window.CRISP_RUNTIME_CONFIG = {
			session_merge: true
		};

		let s = document.createElement('script');
		s.src = 'https://client.crisp.chat/l.js';
		s.async = true;
		s.onload = () => {
			loaded = true;
		};
		document.getElementsByTagName('head')[0].appendChild(s);

		if (localStorage.getItem('chatSupportHasMessageStore')) {
			$chatSupportHasMessageStore = true;
		}
	});

	function updateChat() {
		if ($chatEnabled) {
			window.$crisp.push(['do', 'chat:show']);
			if ($chattingWithUser) {
				window.$crisp.push(['do', 'chat:open']);
			}
		} else {
			window.$crisp.push(['do', 'chat:hide']);
		}
	}

	$effect(() => {
		if ($adminStore) return;
		if (!mounted && loaded) {
			mountChat();
			updateChat();
		} else if (mounted && $businessStore && window.CRISP_TOKEN_ID !== $businessStore.id) {
			window.CRISP_TOKEN_ID = $businessStore.id;
			if ($userStore && $businessStore) {
				window.$crisp.push(['set', 'user:email', [$userStore.email]]);
				window.$crisp.push(['set', 'user:phone', [$userStore.phone]]);

				if ($businessStore.logo) {
					window.$crisp.push([
						'set',
						'user:avatar',
						[$businessStore.logo.replace('.dev', '.com')]
					]);
				}
				window.$crisp.push([
					'set',
					'user:nickname',
					[
						($adminStore ? '[ADMIN] ' : '') +
							($userStore.firstName ?? '') +
							' ' +
							($userStore.lastName ?? '') +
							' (' +
							$businessStore.name +
							')'
					]
				]);
			}
			window.$crisp.push(['do', 'session:reset']);
			window.$crisp.push(['safe', true]);
			updateChat();
		}
	});

	$effect(() => updateChat());

	$effect(() => {
		if ($businessStore && $hasConfigurationIssues) {
			$chatEnabled = true;
		}
	});

	$effect(() => {
		if (page.route.id && !page.route.id.startsWith('/(app)/(connected)/(app)')) {
			$chatEnabled = true;
		}
	});

	$effect(() => {
		if ($chatSupportHasMessageStore) {
			localStorage.setItem('chatSupportHasMessageStore', 'true');
		} else if (browser) {
			localStorage.removeItem('chatSupportHasMessageStore');
		}
	});
</script>
